export const updateLocalStorageFilters = (tableSettingsName, tableParamRef) => {
  localStorage.setItem(tableSettingsName, JSON.stringify(tableParamRef));
};
